module.exports = __webpack_public_path__ + "img/showbill7.64527a88.jpg";